import React, {useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import DetTunerTable from '../../tables/tunerTables/DetTunerTable'
import { DetTunersContext } from '../../../context/dettuners-context';

const useStyles = makeStyles((theme) => ({
  root: {
    display:"flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width:'100%',
    marginBottom:'1em'
  }
}));


export default function DetTunerTabPanel(props) {
  console.log("render DetTunerTabPanel");

  const classes = useStyles();
  const [detTunerState, detTunerDispatch] = useContext(DetTunersContext);

  return (
    <div className={classes.root}>
      <DetTunerTable data={detTunerState.detectors}></DetTunerTable>
    </div>
  );
}